import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    API_GATEWAY_PATH,
    LoanRequest,
    LoanResponse,
    LoanResponseMultipleInterests,
} from '@impact/data';
import { BehaviorSubject, EMPTY } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoanService {
    private loanData$ = new BehaviorSubject<LoanResponse>({});
    public isLoading$ = new BehaviorSubject<boolean>(false);
    public errorState$ = new BehaviorSubject<boolean>(false);
    public interestValues$ = new BehaviorSubject<any>({});

    private defaultLoanSettings: LoanRequest = {
        paymentTerms: 96,
        isFixedInterest: false,
    };

    get loanData() {
        return this.loanData$.asObservable();
    }

    constructor(private http: HttpClient) {}

    private setData(data: LoanResponseMultipleInterests) {
        this.loanData$.next(data);
        this.isLoading$.next(false);
        this.interestValues$.next({
            fixed: data?.interestRates?.fixed,
            variable: data?.interestRates?.variable,
        });
    }

    fetchLoanData(reqBody: LoanRequest) {
        this.errorState$.next(false);
        setTimeout(() => {
            this.isLoading$.next(true);
        });

        return this.http
            .post<LoanResponseMultipleInterests>(
                `/${API_GATEWAY_PATH}/Loan/CalculateLoanMultipleInterests`,
                reqBody
            )
            .subscribe({
                next: (response) => this.setData(response),
                error: () => this.handleError(),
            });
    }

    getDefaultLoanPrice(price: number) {
        if (!price) {
            return EMPTY;
        }

        const reqBody = {
            // TODO: Add these in umbraco settings?
            ...this.defaultLoanSettings,
            objectprice: price,
            downPayment: price * 0.2,
        };

        return this.requestLoanData(reqBody);
    }

    requestLoanData(reqBody: LoanRequest) {
        return this.http.post<LoanResponse>(
            `/${API_GATEWAY_PATH}/Loan/CalculateLoan`,
            reqBody
        );
    }

    handleError() {
        this.errorState$.next(true);
        this.setData({});
    }
}
